import { Modal, Typography, tokens } from "@sunrun/experience-ui-components";
import { RetailRecordingStatus } from "../types";

type StartRecordingModalProps = {
  status: Extract<RetailRecordingStatus, "prompting" | "starting" | "error">;
  errorMessage: string | null;
  onStart: () => void;
  onNotInStore: () => void;
  showNotInStoreAction: boolean;
  onGoBackToDashboard: () => void;
  showGoBackToDashboardAction: boolean;
};

// Blocking modal shown whenever there is no active recording for today.
const StartRecordingModal = ({
  status,
  errorMessage,
  onStart,
  onNotInStore,
  showNotInStoreAction,
  onGoBackToDashboard,
  showGoBackToDashboardAction,
}: StartRecordingModalProps) => {
  const isStarting = status === "starting";
  const hasError = status === "error";

  const secondaryButton = showNotInStoreAction
    ? {
        text: "I am not in a store",
        onClick: onNotInStore,
        disabled: isStarting,
      }
    : showGoBackToDashboardAction
    ? {
        text: "Go back to Dashboard",
        onClick: onGoBackToDashboard,
        disabled: isStarting,
      }
    : undefined;

  return (
    // Stop mousedown propagation so this modal's useClickOutside doesn't
    // interpret clicks on itself as "outside" if another modal is stacked
    // on top of it (mirrors the pattern in LogHoursReminderModal.tsx).
    <div onMouseDown={(e) => e.stopPropagation()}>
      <Modal
        testId="retail-recording-start-modal"
        hideClose
        type={hasError ? "error" : "info"}
        title="Please start recording"
        primaryButton={{
          text: isStarting ? "Starting..." : "Start recording",
          onClick: onStart,
          disabled: isStarting,
          isLoading: isStarting,
        }}
        secondaryButton={secondaryButton}
      >
        <br />
        <Typography>
          Sunrun requires an active audio recording while you&apos;re working.
          <br />
          Please start recording to continue.
        </Typography>
        {hasError && errorMessage && (
          <>
            <br />
            <Typography color={tokens.ERROR_20}>{errorMessage}</Typography>
          </>
        )}
        <br />
      </Modal>
    </div>
  );
};

export { StartRecordingModal };
